import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { sendOTPPending, sendOTPSuccess, sendOTPFail } from "../slice/otpSlice";

// import axios from "axios";

const Login_API_URL = "profile/otp/submit";
const Rop_Login_API_URL = "profile/otp/v1/submit";
const isRopEnabled = sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;
//const Login_API_URL = "./json/submitOTP.json";

// const data ={
//     "otpRef": "ROP-103940",
//     "otpKey":9590
//    }

const sendLoginOTPData = async otpData => {
  const data = {
    otpRef: otpData.otpRef,
    otpKey: otpData.otpKey
  };
  const headerData = {
    headers: {
      accessToken: `${sessionStorage.getItem("temptoken")}`,
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "Authorization"
    }
  };
  const response = await api.post(Rop_Login_API_URL, data, headerData);
  //const response = await axios.get(Login_API_URL);

  return response;
};
function* sendOTPData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(sendLoginOTPData, payload);
    localStorage.setItem("accesstoken", response?.headers?.authorization);
    window.dispatchEvent(new Event("tokenUpdated"));
    localStorage.setItem("expireTime", response?.headers?.tokenexpiry);
    localStorage.removeItem("followedFlights");
    localStorage.removeItem("recentFromAirport");
    localStorage.removeItem("recentToAirport");
    localStorage.removeItem("tripStatus");
    yield put(sendOTPSuccess(response.data));
  } catch (error) {
    yield put(sendOTPFail(error));
  }
}
export function* watchSendOTPData() {
  yield takeLatest(sendOTPPending.type, sendOTPData);
}